/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState, useMemo } from "react";
import { Avatar_02, Avatar_16 } from "Routes/ImagePath";
import { Link } from "react-router-dom";
import ProfileTab from "./EmployeeProfileTab";
import Breadcrumbs from "components/Breadcrumbs";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { getEmployeeDetailApi } from "api/services/employee";
import { getEmployeeSalaryDetailApi, getAddressApi } from "api/services/employee"
import { useEmployee } from "./../context/directoryContext";
import {toTitleCase, renderEventStatus} from "utils/common"
import Image from "components/Image"
import { formatDateHandler2 } from "utils/common";
import FilterSelect from "components/Form/filterSelect";
import {  useSelector } from 'react-redux';
import ChangePictureModal from "components/modelpopup/EmployeePictureModal";


const Profile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();


  const {
    userData : userDataList, 
    userDataLoading,
} = useSelector((state) => state.common);
const {
  user,
  userLoading
} = useSelector((state) => state.user);
  const {
    loading,
    employeeData,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleEmployeeDetailPage,
    selectedPage,
  } = useEmployee();
  const [userDataOption, setUserDataOption] = useState([]);

  const [userData, setUserData] = useState({});
  const [userSalaryData, setUserSalaryData] = useState({});
  const [pictureModal, setPictureModal] = useState(false);


  const [addresses, setAddresses] = useState([]);
  const [addressLoading, setAddressLoading] = useState(true);




  useEffect(()=>{
   
    let _userData = userDataList?.map(item => {
      return {
        label: ` ${item.emp_no} - ${item.first_name} ${item.middle_name||""} ${item.last_name}`,

          value: item.id
      };
  });
  

    setUserDataOption(_userData)  

},[userDataList])


  // ✅ Fetch addresses from API
  const fetchAddresses = async () => {
    setAddressLoading(true);
    try {
      const response = await getAddressApi({company_user: params?.id});
      setAddresses(response.data?.results); // ✅ Update state with API response
    } catch (error) {
      console.error("Error fetching addresses:", error);
    } finally {
      setAddressLoading(false);
    }
  };

  const fetchDetail = () =>{
    getEmployeeDetailApi(params?.id).then((response) => {
      console.log(response, "REEEEEEE");
      setUserData(response.data);
    });

  }

  useEffect(() => {
    console.log(location, navigate, params, "LLL");
    if (params?.id) {
      fetchDetail()

      getEmployeeSalaryDetailApi(params?.id).then((response) => {
        console.log(response, "SALARY DATAAAAAA");
        setUserSalaryData(response.data)
      })
    }
    fetchAddresses();

  }, [params?.id]);
  // const userData = {
  //   id: 1,
  //   name: "John Doe",
  //   role: "UI/UX Design Team",
  //   jobTitle: "Web Designer",
  //   employeeId: "FT-0001",
  //   dateOfJoin: "1st Jan 2023",
  //   phone: "9876543210",
  //   email: "johndoe@example.com",
  //   birthday: "24th July",
  //   address: "1861 Bayonne Ave, Manchester Township, NJ, 08759",
  //   gender: "Male",
  //   supervisor: {
  //     name: "Jeffery Lalor",
  //     avatar: "assets/img/profiles/avatar-16.jpg",
  //   },
  // };
  const handleClickGoBack = () => {
    navigate(-1);
  };

  const handleClickNext = () => {
    const nextIndex = getIndex + 1;
    if (nextIndex < pageSettings.total) {
      let nextEmployee = userDataOption[nextIndex];
      handleEmployeeDetailPage(nextEmployee.value, nextIndex);
    }
  };

  const handleClickPrevious = () => {
    const prevIndex = getIndex - 1;
    if (prevIndex >= 0) {
      let nextEmployee = userDataOption[prevIndex];
      handleEmployeeDetailPage(nextEmployee.value, prevIndex);
    }
  };

  const changeImage = (image) => {
    let _user = {...userData}
    _user['profile_image'] = image
    setUserData(_user)
  }

  const getIndex = useMemo(()=>{

    const index = userDataOption.findIndex(user => user.value === userData.id);
    return index
    
  },[userData])


  const showReportTo = useMemo(()=>{
    const selected = userData?.employment?.report_to?.id
    const is_access = userDataOption.find(user=> user.value === selected)
    if(is_access){

      return (
        <Link
        to={`/employees/${userData?.employment?.report_to?.id}`}
      >
        {userData?.employment?.report_to?.first_name}{" "}
        {userData?.employment?.report_to?.last_name}
      </Link>
      )
    }
    return(
      <p>
      {userData?.employment?.report_to?.first_name}{" "}
      {userData?.employment?.report_to?.last_name}
    </p>
    )
  },[userData, userDataList])
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          
          <Breadcrumbs
            maintitle="Profile"
            title="Employee"
            subtitle="Profile Detail"
           modal="#add_indicator"
           name="Add New"
           showModal={false}
           linkName="/employees"
          />


        <div >
          <div className="col-md-3 mb-2" >
          <FilterSelect 
           placeholder={"Search user"} options={userDataOption} loading={userDataLoading}
           
          //  isClearable={true}
            onChange={e=>{console.log(e, "EE")
            navigate(`/employees/${e.value}`)
          }} 
            optionLabel={"label"} 
            optionValue={'value'}
              // value={setFilterValue("gender")} 
              
           />

</div>
          </div>



          <div>
          <div className="contact-head">
          
            <div className="row align-items-center">
              <div className="col-sm-6 ">
           
                <ul className="contact-breadcrumb">
                  <li>
                    <Link to="#" onClick={handleClickGoBack}>
                      <i className="las la-arrow-left" /> Employee
                    </Link>
                  </li>
                  <li>
                    {userData?.first_name}  {userData?.last_name}
                  </li>
                </ul>
             

                
              </div>
              <div className="col-sm-6 text-sm-end">
                <div className="contact-pagination">
                  <p>
                    {getIndex+1} of {pageSettings.total}
                  </p>
                  <ul>
                    <li>
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          handleClickPrevious();
                        }}
                        // to="/contact-details"
                      >
                        <i className="las la-arrow-left" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          handleClickNext();
                        }}
                        // to="/contact-details"
                      >
                        <i className="las la-arrow-right" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          </div>

          <div className="card mb-0">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-view">
                    <div className="profile-img-wrap">
                      <div className="profile-img">
                        {
                          user?.id == userData.id &&
                          <Link
                          to="#"
                          onClick={()=>setPictureModal(true)}
                          className="d-flex justify-content-center align-items-center text-white"
                          style={{
                            borderRadius: "50%",
                            position: "absolute",
                            width: 25,
                            height: 25,
                            right: 0,
                            background:"grey"
                          }} 
                          // className="edit-icon"
                          // data-bs-toggle="modal"
                          // data-bs-target="#emergency_contact_modal"
                        >
                          <i className="fa fa-pencil" />
                        </Link>
                        }
                     
                        <Link 
                         to="#" 
                        >
                       
                          <Image  src={userData?.profile_image} type="user" alt="User Image" style={{ objectFit: "cover" }} />
                        
                          {/* <img src={userData?.profile_image} alt="User Image" /> */}
                        </Link>
                        
                      </div>
                    </div>
                    <div className="profile-basic">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="profile-info-left height-100">
                            <h3 className="user-name m-t-0 mb-0">
                              {userData?.first_name} {userData?.middle_name} {userData?.last_name}
                            </h3>
                            <h6 className="text-muted">
                              Position : {userData?.employment?.position?.name}
                            </h6>
                            <small className="text-muted">
                              Department : {userData?.employment?.department?.name}
                            </small>
                            <div className="small text-muted">
                              HR Code : {userData?.emp_no}
                            </div>
                                                          
                              <div className="small  text-muted">
                                Date of Join :{" "}
                                {formatDateHandler2(userData?.employment?.employment_date)}  
                                { renderEventStatus(userData?.employment?.employment_date, "🎉", "", "bg-success" )}

                              </div>

                            {/* <div className="staff-msg">
                              <Link className="btn btn-custom" to="/call/chat">
                                Send Message
                              </Link>
                            </div> */}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <ul className="personal-info">
                            <li>
                              <div className="title">Phone:</div>
                              <div className="text">
                                <Link
                                  to={`tel:${userData?.company_phone_number}`}
                                >
                                  {userData?.company_phone_number}
                                </Link>
                              </div>
                            </li>
                            <li>
                              <div className="title">Email:</div>
                              <div className="text">
                                <Link to={`mailto:${userData?.company_email}`}>
                                  {userData?.company_email}
                                </Link>
                              </div>
                            </li>
                            <li>
                              <div className="title">Birthday:</div>
                              <div className="text">{
                                formatDateHandler2(userData?.birthday)}  
                                 { renderEventStatus(userData?.birthday, "🎂", "Upcoming", "bg-warning" )}

                               
                              </div>
                              </li>
                            {/* <li>
                              <div className="title">Address:</div>
                              <div className="text">{userData?.address}</div>
                            </li> */}
                            <li>
                              <div className="title">Gender:</div>
                              <div className="text">{toTitleCase(userData?.gender||"")}</div>
                            </li>
                            <li>
                              <div className="title">Reports To:</div>
                              <div className="text">
                                <div className="avatar-box">
                                  <div className="avatar avatar-xs">
                                  <Image  src={userData?.employment?.report_to?.profile_image} type="user" alt="User Image" style={{ objectFit: "cover" }} />
                                    {/* <img
                                      src={
                                        userData?.employment?.report_to
                                          ?.profile_image
                                      }
                                      alt="User Image"
                                    /> */}
                                  </div>
                                </div>
                                {showReportTo}
                                {/* <Link
                                  to={`/employees/${userData?.employment?.report_to?.id}`}
                                >
                                  {userData?.employment?.report_to?.first_name}{" "}
                                  {userData?.employment?.report_to?.last_name}
                                </Link> */}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="pro-edit">
                      {/* <Link
                        data-bs-target="#profile_info"
                        data-bs-toggle="modal"
                        className="edit-icon"
                        to="#"
                      >
                        <i className="fa-solid fa-pencil"></i>
                      </Link> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card tab-box">
            <div className="row user-tabs">
              <div className="col-lg-12 col-md-12 col-sm-12 line-tabs">
                <ul className="nav nav-tabs nav-tabs-bottom">
                  <li className="nav-item">
                    <Link
                      to="#emp_profile"
                      data-bs-toggle="tab"
                      className="nav-link active"
                    >
                      Profile
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="#emp_projects"
                      data-bs-toggle="tab"
                      className="nav-link"
                    >
                      Employment
                    </Link>
                  </li>
                  {/* <li className="nav-item">
                    <Link
                      to="#bank_statutory"
                      data-bs-toggle="tab"
                      className="nav-link"
                    >
                      Bank &amp; Statutory
                      <small className="text-danger ms-1">(Admin Only)</small>
                    </Link>
                  </li> */}
                  <li className="nav-item">
                    <Link
                      to="#emp_assets"
                      data-bs-toggle="tab"
                      className="nav-link"
                    >
                      Assets
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="#emp_leaves"
                      data-bs-toggle="tab"
                      className="nav-link"
                    >
                      Leave
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="#emp_documents"
                      data-bs-toggle="tab"
                      className="nav-link"
                    >
                      Documents
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="#emp_expenses"
                      data-bs-toggle="tab"
                      className="nav-link"
                    >
                      Expenses
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* Profile Info Tab */}
          <ProfileTab 
          fetchAddresses={fetchAddresses} 
          userData={userData} 
          userSalaryData={userSalaryData} 
          addressData={addresses} 
          addressLoading={addressLoading}
          fetchDetail={fetchDetail}
           />

          <ChangePictureModal 
          show={pictureModal}
           handleClose={()=>setPictureModal(false)} 
           currentImage={userData?.profile_image}
           id={userData?.id}
           changeImage={changeImage}
           />
        </div>
      </div>
    </>
  );
};

export default Profile;
